/*
  Londonstride cart drawer v2 additions (vanilla, no libraries).
  Impulse's theme.CartForm / theme.CartDrawer still own the AJAX cart: quantity changes,
  /cart?view=ajax re-render, totals, count bubble, discounts, checkout submit.
  This file only adds:
   - round trash button -> routes through Impulse's own quantity handler (qty 0)
   - "Frequently bought together": Add -> /cart/add.js (stays in the drawer), "✓ Added",
     then Impulse's 'cart:build' refresh; size select updates the price
   - slider arrows + progress bar (native horizontal scroll, so touch swipe works)
   - "(n)" item count next to YOUR CART
*/
(function () {
  'use strict';
  var drawer = document.getElementById('CartDrawer');
  if (!drawer || !drawer.classList.contains('ls-cart')) return;

  var products = drawer.querySelector('[data-products]');
  var countEl = drawer.querySelector('[data-ls-cart-count]');
  var routes = (window.theme && theme.routes) || {};
  var addUrl = routes.cartAdd || '/cart/add.js';
  var cartUrl = routes.cart || '/cart.js';

  /* ---------- header count ---------- */
  function syncCount() {
    if (!products || !countEl) return;
    var items = products.querySelector('.cart__items');
    if (items && items.dataset.count != null) countEl.textContent = '(' + items.dataset.count + ')';
  }

  /* ---------- slider ---------- */
  function setupSlider() {
    var fbt = drawer.querySelector('[data-ls-fbt]');
    if (!fbt) return;
    var track = fbt.querySelector('[data-ls-fbt-track]');
    var prev = fbt.querySelector('[data-ls-fbt-prev]');
    var next = fbt.querySelector('[data-ls-fbt-next]');
    var thumb = fbt.querySelector('[data-ls-fbt-thumb]');
    if (!track) return;

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (track.clientWidth === 0) return;
      var isStatic = max <= 2;
      fbt.classList.toggle('is-static', isStatic);
      if (prev) prev.disabled = isStatic || track.scrollLeft <= 2;
      if (next) next.disabled = isStatic || track.scrollLeft >= max - 2;
      if (thumb && !isStatic) {
        var ratio = Math.min(1, track.clientWidth / track.scrollWidth);
        var barW = thumb.parentNode.clientWidth;
        var w = Math.max(24, barW * ratio);
        thumb.style.width = w + 'px';
        thumb.style.transform = 'translateX(' + ((barW - w) * (track.scrollLeft / max)) + 'px)';
      }
    }
    function step(dir) {
      var card = track.querySelector('[data-ls-fbt-card]');
      var gap = parseFloat(getComputedStyle(track).columnGap) || 12;
      var by = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      track.scrollBy({ left: dir * by, behavior: 'smooth' });
    }
    if (!track.dataset.lsBound) {
      track.dataset.lsBound = '1';
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
    }
    update();
    fbt._lsUpdate = update;
  }
  function refreshSlider() {
    var fbt = drawer.querySelector('[data-ls-fbt]');
    if (fbt && fbt._lsUpdate) fbt._lsUpdate();
  }

  function onRender() { syncCount(); setupSlider(); }

  if (products && 'MutationObserver' in window) {
    new MutationObserver(onRender).observe(products, { childList: true });
  }
  onRender();
  window.addEventListener('resize', refreshSlider);
  drawer.addEventListener('transitionend', refreshSlider);
  document.addEventListener('cart:open', function () { setTimeout(refreshSlider, 50); });

  /* ---------- size select -> price + variant id ---------- */
  drawer.addEventListener('change', function (evt) {
    var sel = evt.target.closest && evt.target.closest('[data-ls-fbt-select]');
    if (!sel) return;
    var card = sel.closest('[data-ls-fbt-card]');
    var opt = sel.options[sel.selectedIndex];
    if (!card || !opt) return;
    var btn = card.querySelector('[data-ls-upsell-add]');
    if (btn) btn.setAttribute('data-ls-upsell-add', opt.value);
    var now = card.querySelector('[data-ls-fbt-now]');
    var was = card.querySelector('[data-ls-fbt-was]');
    if (now && opt.dataset.price) now.textContent = opt.dataset.price;
    if (was) {
      if (opt.dataset.was) { was.textContent = opt.dataset.was; was.hidden = false; } else { was.hidden = true; }
    }
  });

  function refreshCart(cart) {
    document.dispatchEvent(new CustomEvent('cart:build'));
    if (cart) document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
  }

  drawer.addEventListener('click', function (evt) {
    /* upsell add */
    var add = evt.target.closest('[data-ls-upsell-add]');
    if (add) {
      evt.preventDefault();
      if (add.disabled) return;
      var id = parseInt(add.getAttribute('data-ls-upsell-add'), 10);
      var label = add.textContent;
      var card = add.closest('[data-ls-fbt-card]');
      var sel = card && card.querySelector('[data-ls-fbt-select]');
      add.disabled = true;
      add.classList.add('is-loading');
      if (sel) sel.disabled = true;
      fetch(addUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function () {
          add.classList.remove('is-loading');
          add.classList.add('is-added');
          add.textContent = '\u2713 Added';
          return fetch(cartUrl + (cartUrl.indexOf('?') === -1 ? '?' : '&') + 't=' + Date.now(), { credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .catch(function () { return null; });
        })
        .then(function (cart) {
          setTimeout(function () { refreshCart(cart); }, 900);
        })
        .catch(function () {
          add.disabled = false;
          add.classList.remove('is-loading');
          add.textContent = label;
          if (sel) sel.disabled = false;
        });
      return;
    }

    /* trash -> Impulse quantity handler (0 removes the line) */
    var remove = evt.target.closest('[data-ls-remove]');
    if (remove) {
      var row = remove.closest('.cart__item');
      var input = row && row.querySelector('.js-qty__num');
      if (!input) return; // fall back to the link (full page)
      evt.preventDefault();
      row.classList.add('is-removing');
      input.value = 0;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
})();
